import {
  PROJECT_PATHS,
  PROJECT_PATHS_FOR_CONSOLIDATED_WORKSPACES,
  RUN_PATHS,
} from './paths';
import {SimpleRoute} from './routes';
import {RouteData} from './types';

/**
 * For consolidated workspaces, run paths are nested under project page
 * instead of being a separate page at the root. This is feature flagged.
 * After rollout, remove this util and update ROUTES/ROUTES_DATA directly.
 */
export function convertForConsolidatedWorkspaces<
  T extends SimpleRoute | RouteData,
>(data: T[], isWorkspaceConsolidationEnabled: boolean): T[] {
  if (!isWorkspaceConsolidationEnabled) {
    return data;
  }

  return (
    data
      // exclude run paths from root routes
      .filter(route => route.path !== RUN_PATHS)
      // nest run paths under project paths instead
      .map(route =>
        route.path === PROJECT_PATHS
          ? ({
              ...route,
              path: PROJECT_PATHS_FOR_CONSOLIDATED_WORKSPACES,
            } as T)
          : route
      )
  );
}
